import { render, staticRenderFns } from "./Japanese.vue?vue&type=template&id=02a56214"
import script from "./Japanese.vue?vue&type=script&lang=js"
export * from "./Japanese.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports